import get from "lodash/get";
import { Moment } from "moment";
import moment from "moment-timezone";

function proxyDefaults(proxyObject: { default: any; [key: string]: any }) {
  return new Proxy(proxyObject, {
    get(target, prop) {
      return get(target, prop, target.default);
    }
  });
}

function getFirstName(name: string) {
  if (!name) {
    return name;
  }
  const nameParts = name.split(" ").filter((s: string) => !!s.trim());
  if (nameParts.length > 1) {
    return nameParts[0];
  }
  return name;
}

function centsToDollars(cents: number, skipDollarSign?: boolean): string {
  return `${skipDollarSign ? "" : "$"}${(cents / 100).toLocaleString("en-US", {
    maximumFractionDigits: 2
  })}`;
}

const isWeekend = (date: Moment) => {
  const day = date.day();
  return day === 6 || day === 0;
};

function getCalendarStartDate() {
  let startDate = moment()
    .add(1, "day")
    .startOf("day");

  if (moment.tz("America/New_York").hour() >= 9) {
    startDate = moment()
      .add(2, "day")
      .startOf("day");
  }

  return startDate;
}

const genderMap = proxyDefaults({
  m: "Male",
  f: "Female",
  default: "Unknown"
});

function formatGender(gender: string) {
  return genderMap[gender];
}

export {
  formatGender,
  proxyDefaults,
  getFirstName,
  centsToDollars,
  isWeekend,
  getCalendarStartDate
};
